import { lazy } from 'react';

export const RegistrationPage = lazy(() => import('./RegistrationPage'));
